import isString from 'lodash/isString'
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom'
import * as conditions from 'ol/events/condition'

// a priori utilisé par Ofea
class CustomMouseWheelZoom extends MouseWheelZoom {
  constructor (options) {
    options = options || { }
    if (options.condition && isString(options.condition)) {
      if (conditions[options.condition]) {
        options.condition = conditions[options.condition]
      } else {
        console.warn(`La condition ${options.condition} n'existe pas pour l'interaction CustomMouseWheelZoom`)
      }
    }

    super(options)
  }
}

export default CustomMouseWheelZoom
